/* ++++++++++ --------------- EXPORT : DATA QUESTIONS ANSWERED : STYLES --------------- ++++++++++ */
export default theme => ({
    questionsanswered:{

    }
});
